module.exports = __webpack_public_path__ + "static/media/19.b06c38c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/19.jpg
// module id = 478
// module chunks = 0